define('lib/collection/FilterableCollection',['require','lib/collection/BaseCollection','underscore'],function (require) {

	var BaseCollection = require('lib/collection/BaseCollection');
	var _ = require('underscore'); // pin to Underscore: global window._ may be a lodash build that drops the _.each context arg
	
	/**
	 * Filtrable collection
	 * You can apply filter to collection and it will reset data
	 * 
	 * @class FilterableCollection
	 */
	return BaseCollection.extend({
		
		_dataCollection: null,
		_filters: null,
		
		/**
		 * Inits instance
		 */
		initialize: function () {
			BaseCollection.prototype.initialize.call(this);
			
			this._filters = [];
			this.listenTo(this, 'sync', this._updateData);
			
			this._dataCollection = new BaseCollection();
		},

		getDataCollection: function () {
			return this._dataCollection;
		},

		/**
		 * Adds filter callback function. This function will be called for each 
		 * model when in performFilters method. If this function return true model 
		 * will be added to collection, else skip this models
		 * 
		 * @param Function filter
		 */
		addFilter: function (filter) {
			this._filters.push(filter);
			// If the collection already synced before this filter was registered
			// (e.g. a step object rebuilt after clearSteps() racing the fetch),
			// re-apply filters now instead of leaving the unfiltered reset in place.
			if (this._once_synced) {
				this.performFilters();
			}
		},
		
		/**
		 * Reset all filters. And reset collection.
		 */
		resetFilters: function () {
			this._filters = [];
		},
		
		/**
		 * Performs filters for each model and reset model with filtered models
		 */
		performFilters: function () {
			var models = [];
			this._dataCollection.each(function (model) {
				var valid = true;
				_.each(this._filters, function (filter) {
					valid = valid && filter(model);
				}, this);
				
				if (valid) {
					models.push(model);
				}
			}, this);

			this.reset(models);
		},
		
		/**
		 * Set comparator for sorting
		 * 
		 * @param Function comparator
		 */
		setComparator: function (comparator) {
			this.comparator = comparator;
		},
		
		/**
		 * Updates data in current collection after sync from server
		 */
		_updateData: function () {
            this._once_synced = true;
			this._dataCollection.reset(this.where());
			this.performFilters();
		}
		
	});
	
});
